const UserTourGuideConstants = {
  DISABLE_TOUR_SUCESS: "DISABLE_TOUR_SUCESS",
  DISABLE_TOUR_FAILURE: "DISABLE_TOUR_FAILURE",
};

export default UserTourGuideConstants;
